import type {
  DynamicPricingMode,
  PricingConfigurationPreviewResponse,
  PricingOwnershipAdoptionRequest,
} from '@/shared/api';
import { PricingOwnershipAdoptionControls } from './PricingOwnershipAdoptionControls';
import { PricingPreviewAttestation } from './PricingPreviewAttestation';
import { PricingPreviewCodes } from './PricingPreviewCodes';
import { PricingPreviewDays } from './PricingPreviewDays';
import { PricingPreviewSummary } from './PricingPreviewSummary';
import { previewHints } from './previewModel';

/** Inhalt einer Vorschau: Zahlen, Gültigkeit, Übergabe, Hinweise und betroffene Tage – soweit berechnet. */
export function PricingPreviewReady(props: {
  mode: DynamicPricingMode;
  currency: string;
  preview: PricingConfigurationPreviewResponse;
  ownershipAdoption: PricingOwnershipAdoptionRequest;
  saving: boolean;
  onOwnershipAdoptionChange: (value: PricingOwnershipAdoptionRequest) => void;
}) {
  const { preview } = props;
  // Mit Sperrgrund rechnet der Server keinen Tag; die Sperre nennt dann der Kopf.
  const calculated = preview.days.length > 0 || preview.canActivate;
  return (
    <>
      {props.mode === 'MinimumStayOnly' && (
        <p className="bg-card-alt rounded-control px-3.5 py-2.5 text-[13px]">
          Nur Mindestaufenthalt: Preise bleiben unverändert und werden nicht übertragen.
        </p>
      )}
      {calculated && <PricingPreviewSummary summary={preview.summary} />}
      {calculated && <PricingPreviewAttestation expiresAtUtc={preview.expiresAtUtc} />}
      <PricingOwnershipAdoptionControls
        impact={preview.ownershipAdoption}
        value={props.ownershipAdoption}
        disabled={props.saving}
        onChange={props.onOwnershipAdoptionChange}
      />
      <PricingPreviewCodes hints={previewHints(preview)} />
      {calculated && <PricingPreviewDays days={preview.days} currency={props.currency} />}
    </>
  );
}
